import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Pagination, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react"
import Blog from "./Blog/Blog";
import { blogData as BlogData } from "../../model/BlogData";
import { getBlogs, getPublishedBlogs } from "../../services/BlogService";
import Loading from "../../components/Loading/Loading";
import { useLocation, useParams } from "react-router-dom";
import { Utility } from "../../utility/Utility";
import BlogPage from "./BlogPage";
import InfiniteScroll from "react-infinite-scroll-component";

const Blogs = () => {
    const [isLoaded, setIsLoaded] = React.useState<boolean>(false);
    const [blogs, setBlogs] = React.useState<BlogData[]>([]);
    const { '*': blogName } = useParams();
    const [page, setPage] = React.useState(0);
    const [isFetching, setIsFetching] = useState(false);
    const [disableFetch, setDisableFetch] = useState(false);

    useEffect(() => {
        if (!isFetching) {
            return;
        }
        if (blogs.length > 0 && (!disableFetch)) {
            setPage(page + 1);
        }
    }, [isFetching]);

    useEffect(() => {
        if (blogName == "") {
            getPublishedBlogs(page)
                .then((newblogs: BlogData[]) => {
                    if (newblogs.length === 0) {
                        setDisableFetch(true);
                    }
                    blogs.push(...newblogs)
                    setBlogs(blogs);
                    if (page === 0) {
                        setIsLoaded(true);
                    }
                    setIsFetching(false);
                });
        }
    }, [page]);

    return blogName ? <BlogPage />
        : !isLoaded ? <Loading /> : <Box className="page" style={{ position: "relative" }}>
            <Typography
                component="div"
                color="primary"
                sx={{
                    textAlign: "center",
                    fontStyle: "normal",
                    fontWeight: 700,
                    fontSize: "45px",
                    lineHeight: "57px",
                    marginBottom: "25px",
                    textTransform: "uppercase"
                }}>
                Our Blogs
            </Typography>
            <InfiniteScroll
                dataLength={blogs?.length || 0}
                next={() => {
                    if (disableFetch === false) {
                        setIsFetching(true);
                    }
                }}
                hasMore={!disableFetch}
                loader={<></>}
                endMessage={
                    <p style={{ textAlign: 'center', paddingTop: '50px' }}>
                        <b>No more blogs available</b>
                    </p>
                }
            >
                <Grid container spacing={2}>
                    {blogs.map((blog, index) =>
                        <Grid key={'blog' + index} item lg={6} xs={12}>
                            <Blog blog={blog} />
                        </Grid>)}
                </Grid>
            </InfiniteScroll>
        </Box>
}

export default Blogs;